import { render, staticRenderFns } from "./DataListFormation.vue?vue&type=template&id=cf964edc&scoped=true&"
import script from "./DataListFormation.vue?vue&type=script&lang=js&"
export * from "./DataListFormation.vue?vue&type=script&lang=js&"
import style0 from "./DataListFormation.vue?vue&type=style&index=0&id=cf964edc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf964edc",
  null
  
)

export default component.exports